import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './style.scss';
import Img from 'components/common/Img';
import { ITabItem } from 'modules/TabItems/TabItems';

interface ButtonGroupProps {
  items: ITabItem[];
  singleSelect?: boolean;
  onSelect: (index: number) => void;
  selectedIndex?: number[];
  className?: string;
  v2?: boolean;
}

const ButtonGroup = ({ items, singleSelect, onSelect, selectedIndex, className, v2 }: ButtonGroupProps) => {
  const classNameWrapper = cn('btn-group', {
    [className || '']: className,
    _v2: v2,
  });
  return (
    <div className={classNameWrapper}>
      {items &&
        items.length > 0 &&
        items.map((item, index) => {
          const isSelected = singleSelect ? item.isSelected : (selectedIndex || []).indexOf(index) !== -1;
          const customClass = cn({
            selected: isSelected,
          });
          const onClick = () => onSelect(index);
          return (
            <button key={index} className={customClass} onClick={onClick}>
              {item.label} {item.additionName && `(${item.additionName})`}
              {isSelected && item.icSrc && <Img src={item.icSrc} alt="ic-scr" />}
            </button>
          );
        })}
    </div>
  );
};

export default ButtonGroup;
